import { IconButton, withStyles } from '@material-ui/core';
import { red } from 'globals/colors';

// eslint-disable-next-line import/prefer-default-export
export const StyledIconButton = withStyles(({ spacing }) => ({
  root: {
    width: 46,
    minWidth: 46,
    height: 46,
    marginRight: spacing(1),
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: spacing(1.2),
      height: spacing(1.2),
      borderRadius: spacing(0.6),
      background: red.V1,
      transform: `translate(-50%, -50%) translate(9px, 6px)`,
      opacity: 0,
    },
    '&.withUnreadStatus::after': {
      opacity: 1,
    },
  },
}))(IconButton);
